import { render, staticRenderFns } from "./FaturaAlacakForm.vue?vue&type=template&id=66757a93"
import script from "./FaturaAlacakForm.vue?vue&type=script&lang=ts"
export * from "./FaturaAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports